// function getAjax(url, success) {
//     var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
//     xhr.open('GET', url);
//     xhr.onreadystatechange = function() {
//         if (xhr.readyState>3 && xhr.status==200) {
//             success(xhr.responseText);
//         } else if (xhr.status !== 200) {
//             console.log('Request failed.  Returned status of ' + xhr.status + ' and a ready state of ' + xhr.readyState);
//         }
//     };
//     xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
//     xhr.send();
//     return xhr;
// }

function allLodges() {



    // $('.content-main .index-listing .select').click(function( event ) {

    //     var ul_obj = $(this);

    //     ul_obj.toggleClass('active');
    //     $.each($('.content-main .index-listing .select li'), function( i, l ) {

    //         var orderby = $(this).find('a').attr('data-by');
    //         var orderhow = $(this).find('a').attr('data-how');
    //         var loc = $('#lodgecountry').val();
    //         $(this).click(function( event ) {

    //             ul_obj.find('span.holder').html($(this).find('a').html());
    //             getLodges('%', orderby, orderhow, loc);

    //         });

    //     });
    // });







    // $('#lodges-holder').html('<i class="fa fa-refresh fa-spin fa-5x"></i>');

    // $.ajax({
    //     type: "POST",
    //     url: '/ajax/responsive/get_lodges.php?country='+country+'&orderBy='+orderBy+'&orderHow='+orderHow+'&newcountry='+$newcountry,
    //     data : '',
    //     success: function(data) {

    //         $('#lodges-holder').html(data);

    //         $.each($('.vimeo'), function( i, l ) {
    //             $(this).colorbox({iframe: true, innerWidth: "100%", innerHeight: "100%", scrolling: false});
    //         });
    //     }
    // });
}

export default allLodges;